<template>
  <form v-on:submit.prevent="save()">
    <md-card>
      <md-card-header :data-background-color="dataBackgroundColor">
        <div class="md-layout md-gutter">
          <div class="md-layout-item d-size-90">
            <h4 class="title">Nueva seña</h4>
          </div>
          <div class="md-layout-item md-size-10">
            <md-button class="md-button" @click="$router.go(-1)"
              >Volver</md-button
            >
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100 md-size-100">
            <md-field>
              <label>N° Factura</label>
              <md-input
                v-model="Sena.num_factura"
                type="number"
                disabled
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Seña</label>
              <md-input
                v-model="Sena.monto"
                type="number"
                step="0.01"
                min="0.00"
                required
              ></md-input>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-50">
            <md-field>
              <label>Metodo de pago</label>
              <md-select
                v-model="Sena.metodo"
                name="metodo"
                id="metodo"
                required
              >
                <md-option value="efectivo">Efectivo</md-option>
                <md-option value="tarjeta">Tarjeta</md-option>
              </md-select>
            </md-field>
          </div>
          <div class="md-layout-item md-small-size-100 md-size-100">
            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success"
                >Agregar Seña</md-button
              >
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </form>
</template>
<script>
import axios from "axios";
import Global from "../../Global";
import Sena from "../../models/sena";
export default {
  name: "DetalleShow",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      url: Global.url,
      Sena: new Sena("", "", "")
    };
  },
  mounted() {
    var id_pedido = this.$route.params.id;
    axios
      .get(this.url + "pedido/" + id_pedido, {
        headers: { ApiToken: localStorage.usertoken }
      })
      .then(res => {
        this.Sena.num_factura = res.data.num_factura;
      });
  },
  methods: {
    save() {
      axios
        .post(this.url + "pedido/nueva-sena/save", this.Sena, {
          headers: { ApiToken: localStorage.usertoken }
        })
        .then(Response => {
          if (Response.status == 200) {
            this.$router.go(-1);
          }
        })
        .catch(error => {
          alert(error);
        });
    }
  }
};
</script>
<style></style>
